import Vue from 'vue'
import Vuex from 'vuex'
import activity from './modules/activity'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    activity,
  },
  getters
})

export default store
